import Field, { FieldProps } from '../field/Field';
import React from 'react';

interface TextFieldProps extends Omit<FieldProps, 'type'> {}

const TextField = (props: TextFieldProps) => <Field type="text" {...props} />;

export default TextField;
